import { Star, BadgeCheck, ShieldCheck, Clock, Users, MapPin } from 'lucide-react'
import { business } from '../../config/business'
import SectionWrapper from '../ui/SectionWrapper'

const ICON_MAP = { Star, BadgeCheck, ShieldCheck, Clock, Users, MapPin }

export default function WhyUs() {
  return (
    <SectionWrapper id="why-us" bg="white">
      <div className="max-w-6xl mx-auto px-4">
        {/* Section header */}
        <div className="text-center mb-14">
          <span className="fade-in-up inline-block text-accent-500 font-semibold text-sm uppercase tracking-widest mb-3">
            Why Fateh
          </span>
          <h2 className="fade-in-up font-heading font-bold text-navy-900 text-4xl md:text-5xl">
            Why Choose Us
          </h2>
          <p className="fade-in-up text-ink-600 text-lg mt-4 max-w-xl mx-auto">
            Certified, local, and available around the clock — here's what sets us apart.
          </p>
        </div>

        {/* Trust signal grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
          {business.trustSignals.map((signal) => {
            const Icon = ICON_MAP[signal.icon] ?? Star
            return (
              <div
                key={signal.label}
                className="fade-in-up flex flex-col items-start gap-4 p-6 rounded-xl border border-surface-100 bg-surface-0 hover:border-accent-500/30 hover:shadow-sm transition-all duration-200"
              >
                <div className="w-11 h-11 rounded-lg bg-accent-50 flex items-center justify-center shrink-0">
                  <Icon size={20} className="text-accent-500" />
                </div>
                <div>
                  <p className="font-heading font-bold text-navy-800 text-base leading-tight mb-1">
                    {signal.label}
                  </p>
                  <p className="text-ink-600 text-sm leading-snug">{signal.detail}</p>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </SectionWrapper>
  )
}
